export const REQUEST_UPDATE_LANDING_PAGE = 'REQUEST_UPDATE_CONVERSION';
export const UPDATE_LANDING_PAGE_SUCCESS = 'UPDATE_LANDING_PAGE_SUCCESS';
export const UPDATE_LANDING_PAGE_ERROR = 'UPDATE_LANDING_PAGE_ERROR';

export const REQUEST_DELETE_LANDING_PAGE = 'REQUEST_DELETE_LANDING_PAGE';
export const DELETE_LANDING_PAGE_SUCCESS = 'DELETE_LANDING_PAGE_SUCCESS';
export const DELETE_LANDING_PAGE_ERROR = 'DELETE_LANDING_PAGE_ERROR';

export const REQUEST_DUPLICATE_LANDING_PAGE = 'REQUEST_DUPLICATE_LANDING_PAGE';
export const DUPLICATE_LANDING_PAGE_SUCCESS = 'DUPLICATE_LANDING_PAGE_SUCCESS';
export const DUPLICATE_LANDING_PAGE_ERROR = 'DUPLICATE_LANDING_PAGE_ERROR';
